//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */

// ReSharper disable InconsistentNaming

export class ApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "kimai.monkeyjumplabs.com";
    }

    /**
     * Sets the value of a meta-field for an existing activity
     * @param id Activity record ID to set the meta-field value for
     * @param body (optional)
     * @return Sets the value of an existing/configured meta-field. You cannot create unknown meta-fields, if the given name is not a configured meta-field, this will return an exception.
     */
    meta(id: number, body: Body | null | undefined): Promise<ActivityEntity> {
        let url_ = this.baseUrl + "/api/activities/{id}/meta";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeta(_response);
        });
    }

    protected processMeta(response: Response): Promise<ActivityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityEntity>(null as any);
    }

    /**
     * Returns a collection of activities
     * @param project (optional) Project ID to filter activities
     * @param projects (optional) Comma separated list of project IDs to filter activities
     * @param visible (optional) Visibility status to filter activities. Allowed values: 1=visible, 2=hidden, 3=all (default: 1)
     * @param globals (optional) Use if you want to fetch only global activities. Allowed values: true (default: false)
     * @param globalsFirst (optional) Deprecated parameter, value is not used any more
     * @param orderBy (optional) The field by which results will be ordered. Allowed values: id, name, project (default: name)
     * @param order (optional) The result order. Allowed values: ASC, DESC (default: ASC)
     * @param term (optional) Free search term
     * @return Returns a collection of activity entities
     */
    activitiesAll(project: string | null | undefined, projects: string | null | undefined, visible: string | null | undefined, globals: string | null | undefined, globalsFirst: string | null | undefined, orderBy: string | null | undefined, order: string | null | undefined, term: string | null | undefined): Promise<ActivityCollection[]> {
        let url_ = this.baseUrl + "/api/activities?";
        if (project !== undefined && project !== null)
            url_ += "project=" + encodeURIComponent("" + project) + "&";
        if (projects !== undefined && projects !== null)
            url_ += "projects=" + encodeURIComponent("" + projects) + "&";
        if (visible !== undefined && visible !== null)
            url_ += "visible=" + encodeURIComponent("" + visible) + "&";
        if (globals !== undefined && globals !== null)
            url_ += "globals=" + encodeURIComponent("" + globals) + "&";
        if (globalsFirst !== undefined && globalsFirst !== null)
            url_ += "globalsFirst=" + encodeURIComponent("" + globalsFirst) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesAll(_response);
        });
    }

    protected processActivitiesAll(response: Response): Promise<ActivityCollection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ActivityCollection.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityCollection[]>(null as any);
    }

    /**
     * Creates a new activity
     * @return Returns the new created activity
     */
    activitiesPOST(body: ActivityEditForm): Promise<ActivityEntity> {
        let url_ = this.baseUrl + "/api/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesPOST(_response);
        });
    }

    protected processActivitiesPOST(response: Response): Promise<ActivityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityEntity>(null as any);
    }

    /**
     * Returns one activity
     * @param id Activity ID to fetch
     * @return Returns one activity entity
     */
    activitiesGET(id: number): Promise<ActivityEntity> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesGET(_response);
        });
    }

    protected processActivitiesGET(response: Response): Promise<ActivityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityEntity>(null as any);
    }

    /**
     * Update an existing activity
     * @param id Activity ID to update
     * @return Returns the updated activity
     */
    activitiesPATCH(body: ActivityEditForm, id: number): Promise<ActivityEntity> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesPATCH(_response);
        });
    }

    protected processActivitiesPATCH(response: Response): Promise<ActivityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityEntity>(null as any);
    }

    /**
     * Returns a collection of all rates for one activity
     * @param id The activity whose rates will be returned
     * @return Returns a collection of activity rate entities
     */
    ratesAll(id: number): Promise<ActivityRate[]> {
        let url_ = this.baseUrl + "/api/activities/{id}/rates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesAll(_response);
        });
    }

    protected processRatesAll(response: Response): Promise<ActivityRate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ActivityRate.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityRate[]>(null as any);
    }

    /**
     * Adds a new rate to an activity
     * @param id The activity to add the rate for
     * @return Returns the new created rate
     */
    ratesPOST(id: number, body: ActivityRateForm): Promise<ActivityRate> {
        let url_ = this.baseUrl + "/api/activities/{id}/rates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesPOST(_response);
        });
    }

    protected processRatesPOST(response: Response): Promise<ActivityRate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityRate.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityRate>(null as any);
    }

    /**
     * Deletes one rate for an activity
     * @param id The activity whose rate will be removed
     * @param rateId The rate to remove
     * @return Returns no content: 204 on successful delete
     */
    ratesDELETE(id: number, rateId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/activities/{id}/rates/{rateId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (rateId === undefined || rateId === null)
            throw new Error("The parameter 'rateId' must be defined.");
        url_ = url_.replace("{rateId}", encodeURIComponent("" + rateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {}
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesDELETE(_response);
        });
    }

    protected processRatesDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns the user specific locale configuration
     * @return Returns the locale specific configurations for this user
     */
    i18n(): Promise<I18nConfig> {
        let url_ = this.baseUrl + "/api/config/i18n";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processI18n(_response);
        });
    }

    protected processI18n(response: Response): Promise<I18nConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = I18nConfig.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<I18nConfig>(null as any);
    }

    /**
     * Returns the timesheet configuration
     * @return Returns the instance specific timesheet configuration
     */
    timesheet(): Promise<TimesheetConfig> {
        let url_ = this.baseUrl + "/api/config/timesheet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimesheet(_response);
        });
    }

    protected processTimesheet(response: Response): Promise<TimesheetConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetConfig.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetConfig>(null as any);
    }

    /**
     * Sets the value of a meta-field for an existing customer
     * @param id Customer record ID to set the meta-field value for
     * @param body (optional)
     * @return Sets the value of an existing/configured meta-field. You cannot create unknown meta-fields, if the given name is not a configured meta-field, this will return an exception.
     */
    meta2(id: number, body: Body2 | null | undefined): Promise<CustomerEntity> {
        let url_ = this.baseUrl + "/api/customers/{id}/meta";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeta2(_response);
        });
    }

    protected processMeta2(response: Response): Promise<CustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEntity>(null as any);
    }

    /**
     * Returns a collection of customers
     * @param visible (optional) Visibility status to filter activities (1=visible, 2=hidden, 3=both)
     * @param order (optional) The result order. Allowed values: ASC, DESC (default: ASC)
     * @param orderBy (optional) The field by which results will be ordered. Allowed values: id, name (default: name)
     * @param term (optional) Free search term
     * @return Returns a collection of customer entities
     */
    customersAll(visible: string | null | undefined, order: string | null | undefined, orderBy: string | null | undefined, term: string | null | undefined): Promise<CustomerCollection[]> {
        let url_ = this.baseUrl + "/api/customers?";
        if (visible !== undefined && visible !== null)
            url_ += "visible=" + encodeURIComponent("" + visible) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomersAll(_response);
        });
    }

    protected processCustomersAll(response: Response): Promise<CustomerCollection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CustomerCollection.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerCollection[]>(null as any);
    }

    /**
     * Creates a new customer
     * @return Returns the new created customer
     */
    customersPOST(body: CustomerEditForm): Promise<CustomerEntity> {
        let url_ = this.baseUrl + "/api/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomersPOST(_response);
        });
    }

    protected processCustomersPOST(response: Response): Promise<CustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEntity>(null as any);
    }

    /**
     * Returns one customer
     * @return Returns one customer entity
     */
    customersGET(id: string): Promise<CustomerEntity> {
        let url_ = this.baseUrl + "/api/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomersGET(_response);
        });
    }

    protected processCustomersGET(response: Response): Promise<CustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEntity>(null as any);
    }

    /**
     * Update an existing customer
     * @param id Customer ID to update
     * @return Returns the updated customer
     */
    customersPATCH(body: CustomerEditForm, id: number): Promise<CustomerEntity> {
        let url_ = this.baseUrl + "/api/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomersPATCH(_response);
        });
    }

    protected processCustomersPATCH(response: Response): Promise<CustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEntity>(null as any);
    }

    /**
     * Returns a collection of all rates for one customer
     * @param id The customer whose rates will be returned
     * @return Returns a collection of customer rate entities
     */
    ratesAll2(id: number): Promise<CustomerRate[]> {
        let url_ = this.baseUrl + "/api/customers/{id}/rates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesAll2(_response);
        });
    }

    protected processRatesAll2(response: Response): Promise<CustomerRate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CustomerRate.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerRate[]>(null as any);
    }

    /**
     * Adds a new rate to a customer
     * @param id The customer to add the rate for
     * @return Returns the new created rate
     */
    ratesPOST2(id: number, body: CustomerRateForm): Promise<CustomerRate> {
        let url_ = this.baseUrl + "/api/customers/{id}/rates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesPOST2(_response);
        });
    }

    protected processRatesPOST2(response: Response): Promise<CustomerRate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerRate.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerRate>(null as any);
    }

    /**
     * Deletes one rate for an customer
     * @param id The customer whose rate will be removed
     * @param rateId The rate to remove
     * @return Returns no content: 204 on successful delete
     */
    ratesDELETE2(id: number, rateId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customers/{id}/rates/{rateId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (rateId === undefined || rateId === null)
            throw new Error("The parameter 'rateId' must be defined.");
        url_ = url_.replace("{rateId}", encodeURIComponent("" + rateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {}
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesDELETE2(_response);
        });
    }

    protected processRatesDELETE2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets the value of a meta-field for an existing project
     * @param id Project record ID to set the meta-field value for
     * @param body (optional)
     * @return Sets the value of an existing/configured meta-field. You cannot create unknown meta-fields, if the given name is not a configured meta-field, this will return an exception.
     */
    meta3(id: number, body: Body3 | null | undefined): Promise<ProjectEntity> {
        let url_ = this.baseUrl + "/api/projects/{id}/meta";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeta3(_response);
        });
    }

    protected processMeta3(response: Response): Promise<ProjectEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEntity>(null as any);
    }

    /**
     * Returns a collection of projects.
     * @param customer (optional) Customer ID to filter projects
     * @param customers (optional) Comma separated list of customer IDs to filter projects
     * @param visible (optional) Visibility status to filter projects. Allowed values: 1=visible, 2=hidden, 3=both (default: 1)
     * @param start (optional) Only projects that started before this date will be included. Allowed format: HTML5 (default: now, if end is also empty)
     * @param end (optional) Only projects that ended after this date will be included. Allowed format: HTML5 (default: now, if start is also empty)
     * @param ignoreDates (optional) If set, start and end are completely ignored. Allowed values: 1 (default: off)
     * @param order (optional) The result order. Allowed values: ASC, DESC (default: ASC)
     * @param orderBy (optional) The field by which results will be ordered. Allowed values: id, name, customer (default: name)
     * @param term (optional) Free search term
     * @return Returns a collection of project entities
     */
    projectsAll(customer: string | null | undefined, customers: string | null | undefined, visible: string | null | undefined, start: string | null | undefined, end: string | null | undefined, ignoreDates: string | null | undefined, order: string | null | undefined, orderBy: string | null | undefined, term: string | null | undefined): Promise<ProjectCollection[]> {
        let url_ = this.baseUrl + "/api/projects?";
        if (customer !== undefined && customer !== null)
            url_ += "customer=" + encodeURIComponent("" + customer) + "&";
        if (customers !== undefined && customers !== null)
            url_ += "customers=" + encodeURIComponent("" + customers) + "&";
        if (visible !== undefined && visible !== null)
            url_ += "visible=" + encodeURIComponent("" + visible) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (ignoreDates !== undefined && ignoreDates !== null)
            url_ += "ignoreDates=" + encodeURIComponent("" + ignoreDates) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsAll(_response);
        });
    }

    protected processProjectsAll(response: Response): Promise<ProjectCollection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ProjectCollection.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCollection[]>(null as any);
    }

    /**
     * Creates a new project
     * @return Returns the new created project
     */
    projectsPOST(body: ProjectEditForm): Promise<ProjectEntity> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsPOST(_response);
        });
    }

    protected processProjectsPOST(response: Response): Promise<ProjectEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEntity>(null as any);
    }

    /**
     * Returns one project
     * @return Returns one project entity
     */
    projectsGET(id: string): Promise<ProjectEntity> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsGET(_response);
        });
    }

    protected processProjectsGET(response: Response): Promise<ProjectEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEntity>(null as any);
    }

    /**
     * Update an existing project
     * @param id Project ID to update
     * @return Returns the updated project
     */
    projectsPATCH(body: ProjectEditForm, id: number): Promise<ProjectEntity> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsPATCH(_response);
        });
    }

    protected processProjectsPATCH(response: Response): Promise<ProjectEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEntity>(null as any);
    }

    /**
     * Returns a collection of all rates for one project
     * @param id The project whose rates will be returned
     * @return Returns a collection of project rate entities
     */
    ratesAll3(id: number): Promise<ProjectRate[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/rates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesAll3(_response);
        });
    }

    protected processRatesAll3(response: Response): Promise<ProjectRate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ProjectRate.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRate[]>(null as any);
    }

    /**
     * Adds a new rate to an project
     * @param id The project to add the rate for
     * @return Returns the new created rate
     */
    ratesPOST3(id: number, body: ProjectRateForm): Promise<ProjectRate> {
        let url_ = this.baseUrl + "/api/projects/{id}/rates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesPOST3(_response);
        });
    }

    protected processRatesPOST3(response: Response): Promise<ProjectRate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectRate.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRate>(null as any);
    }

    /**
     * Deletes one rate for an project
     * @param id The project whose rate will be removed
     * @param rateId The rate to remove
     * @return Returns no content: 204 on successful delete
     */
    ratesDELETE3(id: number, rateId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{id}/rates/{rateId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (rateId === undefined || rateId === null)
            throw new Error("The parameter 'rateId' must be defined.");
        url_ = url_.replace("{rateId}", encodeURIComponent("" + rateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {}
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatesDELETE3(_response);
        });
    }

    protected processRatesDELETE3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * A testing route for the API
     * @return A simple route that returns a 'pong', which you can use for testing the API
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns information about the Kimai release
     * @return Returns version information about the current release
     */
    version(): Promise<Version> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: Response): Promise<Version> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Version.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Version>(null as any);
    }

    /**
     * Returns information about installed Plugins
     * @return Returns a list of plugin names and versions
     */
    plugins(): Promise<Plugin[]> {
        let url_ = this.baseUrl + "/api/plugins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPlugins(_response);
        });
    }

    protected processPlugins(response: Response): Promise<Plugin[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Plugin.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Plugin[]>(null as any);
    }

    /**
     * Fetch all existing tags
     * @param name (optional) Search term to filter tag list
     * @return Returns the collection of all existing tags as string array
     */
    tagsAll(name: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/tags?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTagsAll(_response);
        });
    }

    protected processTagsAll(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Creates a new tag
     * @return Returns the new created tag
     */
    tagsPOST(body: TagEditForm): Promise<TagEntity> {
        let url_ = this.baseUrl + "/api/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTagsPOST(_response);
        });
    }

    protected processTagsPOST(response: Response): Promise<TagEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TagEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagEntity>(null as any);
    }

    /**
     * Delete a tag
     * @param id Tag ID to delete
     * @return HTTP code 204 for a successful delete
     */
    tagsDELETE(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/tags/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {}
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTagsDELETE(_response);
        });
    }

    protected processTagsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Fetch all existing teams
     * @return Returns the collection of all existing teams
     */
    teamsAll(): Promise<TeamCollection[]> {
        let url_ = this.baseUrl + "/api/teams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeamsAll(_response);
        });
    }

    protected processTeamsAll(response: Response): Promise<TeamCollection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(TeamCollection.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamCollection[]>(null as any);
    }

    /**
     * Creates a new team
     * @return Returns the new created team
     */
    teamsPOST(body: TeamEditForm): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeamsPOST(_response);
        });
    }

    protected processTeamsPOST(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Returns one team
     * @return Returns one team entity
     */
    teamsGET(id: string): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeamsGET(_response);
        });
    }

    protected processTeamsGET(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Update an existing team
     * @param id Team ID to update
     * @return Returns the updated team
     */
    teamsPATCH(body: TeamEditForm, id: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeamsPATCH(_response);
        });
    }

    protected processTeamsPATCH(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Delete a team
     * @param id Team ID to delete
     * @return Delete one team
     */
    teamsDELETE(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {}
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeamsDELETE(_response);
        });
    }

    protected processTeamsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add a new member to a team
     * @param id The team which will receive the new member
     * @param userId The team member to add (User ID)
     * @return Adds a new user to a team.
     */
    membersPOST(id: number, userId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/members/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembersPOST(_response);
        });
    }

    protected processMembersPOST(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Removes a member from the team
     * @param id The team from which the member will be removed
     * @param userId The team member to remove (User ID)
     * @return Removes a user from the team. The teamlead cannot be removed.
     */
    membersDELETE(id: number, userId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/members/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembersDELETE(_response);
        });
    }

    protected processMembersDELETE(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Grant the team access to a customer
     * @param id The team that is granted access
     * @param customerId The customer to grant acecess to (Customer ID)
     * @return Adds a new customer to a team.
     */
    customersPOST2(id: number, customerId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/customers/{customerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomersPOST2(_response);
        });
    }

    protected processCustomersPOST2(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Revokes access for a customer from a team
     * @param id The team whose permission will be revoked
     * @param customerId The customer to remove (Customer ID)
     * @return Removes a customer from the team.
     */
    customersDELETE(id: number, customerId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/customers/{customerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomersDELETE(_response);
        });
    }

    protected processCustomersDELETE(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Grant the team access to a project
     * @param id The team that is granted access
     * @param projectId The project to grant acecess to (Project ID)
     * @return Adds a new project to a team.
     */
    projectsPOST2(id: number, projectId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/projects/{projectId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsPOST2(_response);
        });
    }

    protected processProjectsPOST2(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Revokes access for a project from a team
     * @param id The team whose permission will be revoked
     * @param projectId The project to remove (Project ID)
     * @return Removes a project from the team.
     */
    projectsDELETE(id: number, projectId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/projects/{projectId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsDELETE(_response);
        });
    }

    protected processProjectsDELETE(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Grant the team access to an activity
     * @param id The team that is granted access
     * @param activityId The activity to grant acecess to (Activity ID)
     * @return Adds a new activity to a team.
     */
    activitiesPOST2(id: number, activityId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/activities/{activityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesPOST2(_response);
        });
    }

    protected processActivitiesPOST2(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Revokes access for an activity from a team
     * @param id The team whose permission will be revoked
     * @param activityId The activity to remove (Activity ID)
     * @return Removes a activity from the team.
     */
    activitiesDELETE(id: number, activityId: number): Promise<Team> {
        let url_ = this.baseUrl + "/api/teams/{id}/activities/{activityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesDELETE(_response);
        });
    }

    protected processActivitiesDELETE(response: Response): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Team.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * Returns the collection of recent user activities
     * @param user (optional) User ID to filter timesheets. Needs permission 'view_other_timesheet', pass 'all' to fetch data for all user (default: current user)
     * @param begin (optional) Only records after this date will be included. Default: today - 1 year (format: HTML5)
     * @param size (optional) The amount of entries (default: 10)
     * @return Returns the collection of recent user activities (always the latest entry of a unique working set grouped by customer, project and activity)
     */
    recent(user: string | null | undefined, begin: string | null | undefined, size: string | null | undefined): Promise<TimesheetCollectionExpanded[]> {
        let url_ = this.baseUrl + "/api/timesheets/recent?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (begin !== undefined && begin !== null)
            url_ += "begin=" + encodeURIComponent("" + begin) + "&";
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecent(_response);
        });
    }

    protected processRecent(response: Response): Promise<TimesheetCollectionExpanded[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(TimesheetCollectionExpanded.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetCollectionExpanded[]>(null as any);
    }

    /**
     * Returns the collection of active timesheet records
     * @return Returns the collection of active timesheet records for the current user
     */
    active(): Promise<TimesheetCollectionExpanded[]> {
        let url_ = this.baseUrl + "/api/timesheets/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActive(_response);
        });
    }

    protected processActive(response: Response): Promise<TimesheetCollectionExpanded[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(TimesheetCollectionExpanded.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetCollectionExpanded[]>(null as any);
    }

    /**
     * Stops an active timesheet record
     * @param id Timesheet record ID to stop
     * @return Stops an active timesheet record and returns it afterwards.
     */
    stop(id: number): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}/stop";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Restarts a previously stopped timesheet record for the current user
     * @param id Timesheet record ID to restart
     * @param body (optional)
     * @return Restarts a timesheet record for the same customer, project, activity combination. The current user will be the owner of the new record. Kimai tries to stop running records, which is expected to fail depending on the configured rules. Data will be copied from the original record if requested.
     */
    restart(id: number, body: Body4 | null | undefined): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}/restart";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestart(_response);
        });
    }

    protected processRestart(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Duplicates an existing timesheet record
     * @param id Timesheet record ID to duplicate
     * @return Duplicates a timesheet record, resetting the export state only.
     */
    duplicate(id: number): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}/duplicate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Switch the export state of a timesheet record to (un-)lock it
     * @param id Timesheet record ID to switch export state
     * @return Switches the exported state on the record and therefor locks / unlocks it for further updates. Needs edit_export_*_timesheet permission.
     */
    export(id: number): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Sets the value of a meta-field for an existing timesheet.
     * @param id Timesheet record ID to set the meta-field value for
     * @param body (optional)
     * @return Sets the value of an existing/configured meta-field. You cannot create unknown meta-fields, if the given name is not a configured meta-field, this will return an exception.
     */
    meta4(id: number, body: Body5 | null | undefined): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}/meta";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeta4(_response);
        });
    }

    protected processMeta4(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Returns a collection of timesheet records
     * @param user (optional) User ID to filter timesheets. Needs permission 'view_other_timesheet', pass 'all' to fetch data for all user (default: current user)
     * @param customer (optional) DEPRECATED: Customer ID to filter timesheets (will be removed with 2.0)
     * @param customers (optional) Comma separated list of customer IDs to filter timesheets
     * @param project (optional) DEPRECATED: Project ID to filter timesheets (will be removed with 2.0)
     * @param projects (optional) Comma separated list of project IDs to filter timesheets
     * @param activity (optional) DEPRECATED: Activity ID to filter timesheets (will be removed with 2.0)
     * @param activities (optional) Comma separated list of activity IDs to filter timesheets
     * @param page (optional) The page to display, renders a 404 if not found (default: 1)
     * @param size (optional) The amount of entries for each page (default: 50)
     * @param tags (optional) Comma separated list of tag names
     * @param orderBy (optional) The field by which results will be ordered. Allowed values: id, begin, end, rate (default: begin)
     * @param order (optional) The result order. Allowed values: ASC, DESC (default: DESC)
     * @param begin (optional) Only records after this date will be included (format: HTML5)
     * @param end (optional) Only records before this date will be included (format: HTML5)
     * @param exported (optional) Use this flag if you want to filter for export state. Allowed values: 0=not exported, 1=exported (default: all)
     * @param active (optional) Filter for running/active records. Allowed values: 0=stopped, 1=active (default: all)
     * @param billable (optional) Filter for non-/billable records. Allowed values: 0=non-billable, 1=billable (default: all)
     * @param full (optional) Allows to fetch fully serialized objects including subresources. Allowed values: true (default: false)
     * @param term (optional) Free search term
     * @param modified_after (optional) Only records changed after this date will be included (format: HTML5). Available since Kimai 1.10 and works only for records that were created/updated since then.
     * @return Returns a collection of timesheets records. Be aware that the datetime fields are given in the users local time including the timezone offset via ISO 8601.
     */
    timesheetsAll(user: string | null | undefined, customer: string | null | undefined, customers: string | null | undefined, project: string | null | undefined, projects: string | null | undefined, activity: string | null | undefined, activities: string | null | undefined, page: string | null | undefined, size: string | null | undefined, tags: string | null | undefined, orderBy: string | null | undefined, order: string | null | undefined, begin: string | null | undefined, end: string | null | undefined, exported: string | null | undefined, active: string | null | undefined, billable: string | null | undefined, full: string | null | undefined, term: string | null | undefined, modified_after: string | null | undefined): Promise<TimesheetCollection[]> {
        let url_ = this.baseUrl + "/api/timesheets?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (customer !== undefined && customer !== null)
            url_ += "customer=" + encodeURIComponent("" + customer) + "&";
        if (customers !== undefined && customers !== null)
            url_ += "customers=" + encodeURIComponent("" + customers) + "&";
        if (project !== undefined && project !== null)
            url_ += "project=" + encodeURIComponent("" + project) + "&";
        if (projects !== undefined && projects !== null)
            url_ += "projects=" + encodeURIComponent("" + projects) + "&";
        if (activity !== undefined && activity !== null)
            url_ += "activity=" + encodeURIComponent("" + activity) + "&";
        if (activities !== undefined && activities !== null)
            url_ += "activities=" + encodeURIComponent("" + activities) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (tags !== undefined && tags !== null)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (begin !== undefined && begin !== null)
            url_ += "begin=" + encodeURIComponent("" + begin) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (exported !== undefined && exported !== null)
            url_ += "exported=" + encodeURIComponent("" + exported) + "&";
        if (active !== undefined && active !== null)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        if (billable !== undefined && billable !== null)
            url_ += "billable=" + encodeURIComponent("" + billable) + "&";
        if (full !== undefined && full !== null)
            url_ += "full=" + encodeURIComponent("" + full) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (modified_after !== undefined && modified_after !== null)
            url_ += "modified_after=" + encodeURIComponent("" + modified_after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimesheetsAll(_response);
        });
    }

    protected processTimesheetsAll(response: Response): Promise<TimesheetCollection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(TimesheetCollection.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetCollection[]>(null as any);
    }

    /**
     * Creates a new timesheet record
     * @param full (optional) Allows to fetch fully serialized objects including subresources (TimesheetEntityExpanded). Allowed values: true (default: false)
     * @return Returns the new created timesheet
     */
    timesheetsPOST(body: TimesheetEditForm, full: string | null | undefined): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets?";
        if (full !== undefined && full !== null)
            url_ += "full=" + encodeURIComponent("" + full) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimesheetsPOST(_response);
        });
    }

    protected processTimesheetsPOST(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Returns one timesheet record
     * @param id Timesheet record ID to fetch
     * @return Returns one timesheet record. Be aware that the datetime fields are given in the users local time including the timezone offset via ISO 8601.
     */
    timesheetsGET(id: number): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimesheetsGET(_response);
        });
    }

    protected processTimesheetsGET(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Update an existing timesheet record
     * @param id Timesheet record ID to update
     * @return Returns the updated timesheet
     */
    timesheetsPATCH(id: number, body: TimesheetEditForm): Promise<TimesheetEntity> {
        let url_ = this.baseUrl + "/api/timesheets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimesheetsPATCH(_response);
        });
    }

    protected processTimesheetsPATCH(response: Response): Promise<TimesheetEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimesheetEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetEntity>(null as any);
    }

    /**
     * Delete an existing timesheet record
     * @param id Timesheet record ID to delete
     * @return Delete one timesheet record
     */
    timesheetsDELETE(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/timesheets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {}
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimesheetsDELETE(_response);
        });
    }

    protected processTimesheetsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Return the current user entity
     * @return Return the current user entity.
     */
    me(): Promise<UserEntity> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: Response): Promise<UserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntity>(null as any);
    }

    /**
     * Returns the collection of all registered users
     * @param visible (optional) Visibility status to filter users. Allowed values: 1=visible, 2=hidden, 3=all (default: 1)
     * @param orderBy (optional) The field by which results will be ordered. Allowed values: id, username, alias, email (default: username)
     * @param order (optional) The result order. Allowed values: ASC, DESC (default: ASC)
     * @param term (optional) Free search term
     * @return Returns the collection of all registered users. Required permission: view_user
     */
    usersAll(visible: string | null | undefined, orderBy: string | null | undefined, order: string | null | undefined, term: string | null | undefined): Promise<UserCollection[]> {
        let url_ = this.baseUrl + "/api/users?";
        if (visible !== undefined && visible !== null)
            url_ += "visible=" + encodeURIComponent("" + visible) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsersAll(_response);
        });
    }

    protected processUsersAll(response: Response): Promise<UserCollection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(UserCollection.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCollection[]>(null as any);
    }

    /**
     * Creates a new user
     * @return Returns the new created user
     */
    usersPOST(body: UserCreateForm): Promise<UserEntity> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsersPOST(_response);
        });
    }

    protected processUsersPOST(response: Response): Promise<UserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntity>(null as any);
    }

    /**
     * Return one user entity
     * @param id User ID to fetch
     * @return Return one user entity.
     */
    usersGET(id: number): Promise<UserEntity> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsersGET(_response);
        });
    }

    protected processUsersGET(response: Response): Promise<UserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntity>(null as any);
    }

    /**
     * Update an existing user
     * @param id User ID to update
     * @return Returns the updated user
     */
    usersPATCH(body: UserEditForm, id: number): Promise<UserEntity> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsersPATCH(_response);
        });
    }

    protected processUsersPATCH(response: Response): Promise<UserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserEntity.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntity>(null as any);
    }
}

export class TeamMembership implements ITeamMembership {
    team!: Team;
    teamlead!: boolean;

    constructor(data?: ITeamMembership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.team = data.team && !(<any>data.team).toJSON ? new Team(data.team) : <Team>this.team;
        }
        if (!data) {
            this.team = new Team();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : new Team();
            this.teamlead = _data["teamlead"];
        }
    }

    static fromJS(data: any): TeamMembership {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMembership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["teamlead"] = this.teamlead;
        return data;
    }

    clone(): TeamMembership {
        const json = this.toJSON();
        let result = new TeamMembership();
        result.init(json);
        return result;
    }
}

export interface ITeamMembership {
    team: ITeam;
    teamlead: boolean;
}

export class TeamMember implements ITeamMember {
    user!: User;
    teamlead!: boolean;

    constructor(data?: ITeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
        if (!data) {
            this.user = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
            this.teamlead = _data["teamlead"];
        }
    }

    static fromJS(data: any): TeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["teamlead"] = this.teamlead;
        return data;
    }

    clone(): TeamMember {
        const json = this.toJSON();
        let result = new TeamMember();
        result.init(json);
        return result;
    }
}

export interface ITeamMember {
    user: IUser;
    teamlead: boolean;
}

export class TeamCollection implements ITeamCollection {
    id?: number | undefined;
    name!: string;
    color?: string | undefined;

    constructor(data?: ITeamCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TeamCollection {
        data = typeof data === 'object' ? data : {};
        let result = new TeamCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }

    clone(): TeamCollection {
        const json = this.toJSON();
        let result = new TeamCollection();
        result.init(json);
        return result;
    }
}

export interface ITeamCollection {
    id?: number | undefined;
    name: string;
    color?: string | undefined;
}

export class Team implements ITeam {
    teamlead?: User | undefined;
    users?: User[] | undefined;
    id?: number | undefined;
    name!: string;
    members?: TeamMember[] | undefined;
    customers?: Customer[] | undefined;
    projects?: Project[] | undefined;
    activities?: Activity[] | undefined;
    color?: string | undefined;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.teamlead = data.teamlead && !(<any>data.teamlead).toJSON ? new User(data.teamlead) : <User>this.teamlead;
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new User(item) : <User>item;
                }
            }
            if (data.members) {
                this.members = [];
                for (let i = 0; i < data.members.length; i++) {
                    let item = data.members[i];
                    this.members[i] = item && !(<any>item).toJSON ? new TeamMember(item) : <TeamMember>item;
                }
            }
            if (data.customers) {
                this.customers = [];
                for (let i = 0; i < data.customers.length; i++) {
                    let item = data.customers[i];
                    this.customers[i] = item && !(<any>item).toJSON ? new Customer(item) : <Customer>item;
                }
            }
            if (data.projects) {
                this.projects = [];
                for (let i = 0; i < data.projects.length; i++) {
                    let item = data.projects[i];
                    this.projects[i] = item && !(<any>item).toJSON ? new Project(item) : <Project>item;
                }
            }
            if (data.activities) {
                this.activities = [];
                for (let i = 0; i < data.activities.length; i++) {
                    let item = data.activities[i];
                    this.activities[i] = item && !(<any>item).toJSON ? new Activity(item) : <Activity>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamlead = _data["teamlead"] ? User.fromJS(_data["teamlead"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(TeamMember.fromJS(item));
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(Activity.fromJS(item));
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamlead"] = this.teamlead ? this.teamlead.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["color"] = this.color;
        return data;
    }

    clone(): Team {
        const json = this.toJSON();
        let result = new Team();
        result.init(json);
        return result;
    }
}

export interface ITeam {
    teamlead?: IUser | undefined;
    users?: IUser[] | undefined;
    id?: number | undefined;
    name: string;
    members?: ITeamMember[] | undefined;
    customers?: ICustomer[] | undefined;
    projects?: IProject[] | undefined;
    activities?: IActivity[] | undefined;
    color?: string | undefined;
}

export class TeamEditForm implements ITeamEditForm {
    /** Name of the team */
    name!: string;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    /** All team members */
    members!: Members[];

    constructor(data?: ITeamEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.members) {
                this.members = [];
                for (let i = 0; i < data.members.length; i++) {
                    let item = data.members[i];
                    this.members[i] = item && !(<any>item).toJSON ? new Members(item) : <Members>item;
                }
            }
        }
        if (!data) {
            this.members = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(Members.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }

    clone(): TeamEditForm {
        const json = this.toJSON();
        let result = new TeamEditForm();
        result.init(json);
        return result;
    }
}

export interface ITeamEditForm {
    /** Name of the team */
    name: string;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    /** All team members */
    members: IMembers[];
}

export class UserCollection implements IUserCollection {
    id?: number | undefined;
    alias?: string | undefined;
    username!: string;
    accountNumber?: string | undefined;
    enabled?: boolean | undefined;
    color?: string | undefined;

    constructor(data?: IUserCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.username = _data["username"];
            this.accountNumber = _data["accountNumber"];
            this.enabled = _data["enabled"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): UserCollection {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["username"] = this.username;
        data["accountNumber"] = this.accountNumber;
        data["enabled"] = this.enabled;
        data["color"] = this.color;
        return data;
    }

    clone(): UserCollection {
        const json = this.toJSON();
        let result = new UserCollection();
        result.init(json);
        return result;
    }
}

export interface IUserCollection {
    id?: number | undefined;
    alias?: string | undefined;
    username: string;
    accountNumber?: string | undefined;
    enabled?: boolean | undefined;
    color?: string | undefined;
}

export class UserEntity implements IUserEntity {
    language?: string | undefined;
    timezone?: string | undefined;
    preferences?: UserPreference[] | undefined;
    teams?: Team[] | undefined;
    id?: number | undefined;
    alias?: string | undefined;
    title?: string | undefined;
    avatar?: string | undefined;
    memberships!: TeamMembership;
    username!: string;
    accountNumber?: string | undefined;
    enabled?: boolean | undefined;
    roles?: string[] | undefined;
    color?: string | undefined;

    constructor(data?: IUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.preferences) {
                this.preferences = [];
                for (let i = 0; i < data.preferences.length; i++) {
                    let item = data.preferences[i];
                    this.preferences[i] = item && !(<any>item).toJSON ? new UserPreference(item) : <UserPreference>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
            this.memberships = data.memberships && !(<any>data.memberships).toJSON ? new TeamMembership(data.memberships) : <TeamMembership>this.memberships;
        }
        if (!data) {
            this.memberships = new TeamMembership();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.timezone = _data["timezone"];
            if (Array.isArray(_data["preferences"])) {
                this.preferences = [] as any;
                for (let item of _data["preferences"])
                    this.preferences!.push(UserPreference.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.title = _data["title"];
            this.avatar = _data["avatar"];
            this.memberships = _data["memberships"] ? TeamMembership.fromJS(_data["memberships"]) : new TeamMembership();
            this.username = _data["username"];
            this.accountNumber = _data["accountNumber"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): UserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["timezone"] = this.timezone;
        if (Array.isArray(this.preferences)) {
            data["preferences"] = [];
            for (let item of this.preferences)
                data["preferences"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["title"] = this.title;
        data["avatar"] = this.avatar;
        data["memberships"] = this.memberships ? this.memberships.toJSON() : <any>undefined;
        data["username"] = this.username;
        data["accountNumber"] = this.accountNumber;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["color"] = this.color;
        return data;
    }

    clone(): UserEntity {
        const json = this.toJSON();
        let result = new UserEntity();
        result.init(json);
        return result;
    }
}

export interface IUserEntity {
    language?: string | undefined;
    timezone?: string | undefined;
    preferences?: IUserPreference[] | undefined;
    teams?: ITeam[] | undefined;
    id?: number | undefined;
    alias?: string | undefined;
    title?: string | undefined;
    avatar?: string | undefined;
    memberships: ITeamMembership;
    username: string;
    accountNumber?: string | undefined;
    enabled?: boolean | undefined;
    roles?: string[] | undefined;
    color?: string | undefined;
}

export class UserPreference implements IUserPreference {
    name!: string;
    value?: string | undefined;

    constructor(data?: IUserPreference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UserPreference {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): UserPreference {
        const json = this.toJSON();
        let result = new UserPreference();
        result.init(json);
        return result;
    }
}

export interface IUserPreference {
    name: string;
    value?: string | undefined;
}

export class User implements IUser {
    id?: number | undefined;
    alias?: string | undefined;
    username!: string;
    accountNumber?: string | undefined;
    enabled?: boolean | undefined;
    color?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.username = _data["username"];
            this.accountNumber = _data["accountNumber"];
            this.enabled = _data["enabled"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["username"] = this.username;
        data["accountNumber"] = this.accountNumber;
        data["enabled"] = this.enabled;
        data["color"] = this.color;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id?: number | undefined;
    alias?: string | undefined;
    username: string;
    accountNumber?: string | undefined;
    enabled?: boolean | undefined;
    color?: string | undefined;
}

export class UserEditForm implements IUserEditForm {
    alias?: string | undefined;
    title?: string | undefined;
    accountNumber?: string | undefined;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    email!: string;
    language!: UserEditFormLanguage;
    timezone!: string;
    enabled?: boolean | undefined;
    roles?: Roles[] | undefined;

    constructor(data?: IUserEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.title = _data["title"];
            this.accountNumber = _data["accountNumber"];
            this.color = _data["color"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.timezone = _data["timezone"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["title"] = this.title;
        data["accountNumber"] = this.accountNumber;
        data["color"] = this.color;
        data["email"] = this.email;
        data["language"] = this.language;
        data["timezone"] = this.timezone;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }

    clone(): UserEditForm {
        const json = this.toJSON();
        let result = new UserEditForm();
        result.init(json);
        return result;
    }
}

export interface IUserEditForm {
    alias?: string | undefined;
    title?: string | undefined;
    accountNumber?: string | undefined;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    email: string;
    language: UserEditFormLanguage;
    timezone: string;
    enabled?: boolean | undefined;
    roles?: Roles[] | undefined;
}

export class UserCreateForm implements IUserCreateForm {
    username!: string;
    alias?: string | undefined;
    title?: string | undefined;
    accountNumber?: string | undefined;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    email!: string;
    language!: UserCreateFormLanguage;
    timezone!: string;
    enabled?: boolean | undefined;
    roles?: Roles2[] | undefined;
    /** Plain text password */
    plainPassword!: string;

    constructor(data?: IUserCreateForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.alias = _data["alias"];
            this.title = _data["title"];
            this.accountNumber = _data["accountNumber"];
            this.color = _data["color"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.timezone = _data["timezone"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.plainPassword = _data["plainPassword"];
        }
    }

    static fromJS(data: any): UserCreateForm {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["alias"] = this.alias;
        data["title"] = this.title;
        data["accountNumber"] = this.accountNumber;
        data["color"] = this.color;
        data["email"] = this.email;
        data["language"] = this.language;
        data["timezone"] = this.timezone;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["plainPassword"] = this.plainPassword;
        return data;
    }

    clone(): UserCreateForm {
        const json = this.toJSON();
        let result = new UserCreateForm();
        result.init(json);
        return result;
    }
}

export interface IUserCreateForm {
    username: string;
    alias?: string | undefined;
    title?: string | undefined;
    accountNumber?: string | undefined;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    email: string;
    language: UserCreateFormLanguage;
    timezone: string;
    enabled?: boolean | undefined;
    roles?: Roles2[] | undefined;
    /** Plain text password */
    plainPassword: string;
}

export class TimesheetCollectionExpanded implements ITimesheetCollectionExpanded {
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin!: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    activity!: ActivityExpanded;
    project!: ProjectExpanded;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    exported!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: TimesheetMeta[] | undefined;

    constructor(data?: ITimesheetCollectionExpanded) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.activity = data.activity && !(<any>data.activity).toJSON ? new ActivityExpanded(data.activity) : <ActivityExpanded>this.activity;
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectExpanded(data.project) : <ProjectExpanded>this.project;
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new TimesheetMeta(item) : <TimesheetMeta>item;
                }
            }
        }
        if (!data) {
            this.activity = new ActivityExpanded();
            this.project = new ProjectExpanded();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.id = _data["id"];
            this.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.activity = _data["activity"] ? ActivityExpanded.fromJS(_data["activity"]) : new ActivityExpanded();
            this.project = _data["project"] ? ProjectExpanded.fromJS(_data["project"]) : new ProjectExpanded();
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.exported = _data["exported"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(TimesheetMeta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetCollectionExpanded {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetCollectionExpanded();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["id"] = this.id;
        data["begin"] = this.begin ? this.begin.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["exported"] = this.exported;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        return data;
    }

    clone(): TimesheetCollectionExpanded {
        const json = this.toJSON();
        let result = new TimesheetCollectionExpanded();
        result.init(json);
        return result;
    }
}

export interface ITimesheetCollectionExpanded {
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    activity: IActivityExpanded;
    project: IProjectExpanded;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    exported: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: ITimesheetMeta[] | undefined;
}

export class TimesheetCollection implements ITimesheetCollection {
    activity?: number | undefined;
    project?: number | undefined;
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin!: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    exported!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: TimesheetMeta[] | undefined;

    constructor(data?: ITimesheetCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new TimesheetMeta(item) : <TimesheetMeta>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.project = _data["project"];
            this.user = _data["user"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.id = _data["id"];
            this.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.exported = _data["exported"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(TimesheetMeta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetCollection {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["project"] = this.project;
        data["user"] = this.user;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["id"] = this.id;
        data["begin"] = this.begin ? this.begin.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["exported"] = this.exported;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        return data;
    }

    clone(): TimesheetCollection {
        const json = this.toJSON();
        let result = new TimesheetCollection();
        result.init(json);
        return result;
    }
}

export interface ITimesheetCollection {
    activity?: number | undefined;
    project?: number | undefined;
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    exported: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: ITimesheetMeta[] | undefined;
}

export class TimesheetEntityExpanded implements ITimesheetEntityExpanded {
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin!: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    activity!: ActivityExpanded;
    project!: ProjectExpanded;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    fixedRate?: number | undefined;
    hourlyRate?: number | undefined;
    exported!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: TimesheetMeta[] | undefined;

    constructor(data?: ITimesheetEntityExpanded) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.activity = data.activity && !(<any>data.activity).toJSON ? new ActivityExpanded(data.activity) : <ActivityExpanded>this.activity;
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectExpanded(data.project) : <ProjectExpanded>this.project;
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new TimesheetMeta(item) : <TimesheetMeta>item;
                }
            }
        }
        if (!data) {
            this.activity = new ActivityExpanded();
            this.project = new ProjectExpanded();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.id = _data["id"];
            this.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.activity = _data["activity"] ? ActivityExpanded.fromJS(_data["activity"]) : new ActivityExpanded();
            this.project = _data["project"] ? ProjectExpanded.fromJS(_data["project"]) : new ProjectExpanded();
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.fixedRate = _data["fixedRate"];
            this.hourlyRate = _data["hourlyRate"];
            this.exported = _data["exported"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(TimesheetMeta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetEntityExpanded {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEntityExpanded();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["id"] = this.id;
        data["begin"] = this.begin ? this.begin.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["fixedRate"] = this.fixedRate;
        data["hourlyRate"] = this.hourlyRate;
        data["exported"] = this.exported;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        return data;
    }

    clone(): TimesheetEntityExpanded {
        const json = this.toJSON();
        let result = new TimesheetEntityExpanded();
        result.init(json);
        return result;
    }
}

export interface ITimesheetEntityExpanded {
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    activity: IActivityExpanded;
    project: IProjectExpanded;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    fixedRate?: number | undefined;
    hourlyRate?: number | undefined;
    exported: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: ITimesheetMeta[] | undefined;
}

export class TimesheetEntity implements ITimesheetEntity {
    activity?: number | undefined;
    project?: number | undefined;
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin!: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    fixedRate?: number | undefined;
    hourlyRate?: number | undefined;
    exported!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: TimesheetMeta[] | undefined;

    constructor(data?: ITimesheetEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new TimesheetMeta(item) : <TimesheetMeta>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.project = _data["project"];
            this.user = _data["user"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.id = _data["id"];
            this.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.fixedRate = _data["fixedRate"];
            this.hourlyRate = _data["hourlyRate"];
            this.exported = _data["exported"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(TimesheetMeta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["project"] = this.project;
        data["user"] = this.user;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["id"] = this.id;
        data["begin"] = this.begin ? this.begin.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["fixedRate"] = this.fixedRate;
        data["hourlyRate"] = this.hourlyRate;
        data["exported"] = this.exported;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        return data;
    }

    clone(): TimesheetEntity {
        const json = this.toJSON();
        let result = new TimesheetEntity();
        result.init(json);
        return result;
    }
}

export interface ITimesheetEntity {
    activity?: number | undefined;
    project?: number | undefined;
    user?: number | undefined;
    tags?: string[] | undefined;
    id?: number | undefined;
    begin: Date;
    end?: Date | undefined;
    duration?: number | undefined;
    description?: string | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    fixedRate?: number | undefined;
    hourlyRate?: number | undefined;
    exported: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this timesheet */
    metaFields?: ITimesheetMeta[] | undefined;
}

export class TimesheetEditForm implements ITimesheetEditForm {
    begin!: Date;
    end?: Date | undefined;
    /** Project ID */
    project!: number;
    /** Activity ID */
    activity!: number;
    description?: string | undefined;
    /** Fixed rate */
    fixedRate?: number | undefined;
    /** Hourly rate */
    hourlyRate?: number | undefined;
    /** User ID */
    user?: number | undefined;
    exported?: boolean | undefined;
    billable?: boolean | undefined;
    /** Comma separated list of tags */
    tags?: string | undefined;

    constructor(data?: ITimesheetEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.project = _data["project"];
            this.activity = _data["activity"];
            this.description = _data["description"];
            this.fixedRate = _data["fixedRate"];
            this.hourlyRate = _data["hourlyRate"];
            this.user = _data["user"];
            this.exported = _data["exported"];
            this.billable = _data["billable"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): TimesheetEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["begin"] = this.begin ? this.begin.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["project"] = this.project;
        data["activity"] = this.activity;
        data["description"] = this.description;
        data["fixedRate"] = this.fixedRate;
        data["hourlyRate"] = this.hourlyRate;
        data["user"] = this.user;
        data["exported"] = this.exported;
        data["billable"] = this.billable;
        data["tags"] = this.tags;
        return data;
    }

    clone(): TimesheetEditForm {
        const json = this.toJSON();
        let result = new TimesheetEditForm();
        result.init(json);
        return result;
    }
}

export interface ITimesheetEditForm {
    begin: Date;
    end?: Date | undefined;
    /** Project ID */
    project: number;
    /** Activity ID */
    activity: number;
    description?: string | undefined;
    /** Fixed rate */
    fixedRate?: number | undefined;
    /** Hourly rate */
    hourlyRate?: number | undefined;
    /** User ID */
    user?: number | undefined;
    exported?: boolean | undefined;
    billable?: boolean | undefined;
    /** Comma separated list of tags */
    tags?: string | undefined;
}

export class TagEntity implements ITagEntity {
    id?: number | undefined;
    name!: string;
    color?: string | undefined;

    constructor(data?: ITagEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TagEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }

    clone(): TagEntity {
        const json = this.toJSON();
        let result = new TagEntity();
        result.init(json);
        return result;
    }
}

export interface ITagEntity {
    id?: number | undefined;
    name: string;
    color?: string | undefined;
}

export class TagEditForm implements ITagEditForm {
    /** The tag name (forbidden character: comma) */
    name!: string;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;

    constructor(data?: ITagEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new TagEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }

    clone(): TagEditForm {
        const json = this.toJSON();
        let result = new TagEditForm();
        result.init(json);
        return result;
    }
}

export interface ITagEditForm {
    /** The tag name (forbidden character: comma) */
    name: string;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
}

export class ActivityCollection implements IActivityCollection {
    parentTitle?: string | undefined;
    project?: number | undefined;
    id?: number | undefined;
    name!: string;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this activity */
    metaFields?: ActivityMeta[] | undefined;
    /** If no team is assigned, everyone can access the activity */
    teams?: Team[] | undefined;
    color?: string | undefined;

    constructor(data?: IActivityCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new ActivityMeta(item) : <ActivityMeta>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTitle = _data["parentTitle"];
            this.project = _data["project"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(ActivityMeta.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTitle"] = this.parentTitle;
        data["project"] = this.project;
        data["id"] = this.id;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["color"] = this.color;
        return data;
    }

    clone(): ActivityCollection {
        const json = this.toJSON();
        let result = new ActivityCollection();
        result.init(json);
        return result;
    }
}

export interface IActivityCollection {
    parentTitle?: string | undefined;
    project?: number | undefined;
    id?: number | undefined;
    name: string;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this activity */
    metaFields?: IActivityMeta[] | undefined;
    /** If no team is assigned, everyone can access the activity */
    teams?: ITeam[] | undefined;
    color?: string | undefined;
}

export class ActivityRateForm implements IActivityRateForm {
    /** User ID */
    user?: number | undefined;
    /** The rate (eg. 10.5) */
    rate!: number;
    /** The internal rate (eg. 10.0 or 10) */
    internalRate?: number | undefined;
    /** If "true" each time record gets the same rate, regardless of its duration */
    isFixed?: boolean | undefined;

    constructor(data?: IActivityRateForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): ActivityRateForm {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRateForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["isFixed"] = this.isFixed;
        return data;
    }

    clone(): ActivityRateForm {
        const json = this.toJSON();
        let result = new ActivityRateForm();
        result.init(json);
        return result;
    }
}

export interface IActivityRateForm {
    /** User ID */
    user?: number | undefined;
    /** The rate (eg. 10.5) */
    rate: number;
    /** The internal rate (eg. 10.0 or 10) */
    internalRate?: number | undefined;
    /** If "true" each time record gets the same rate, regardless of its duration */
    isFixed?: boolean | undefined;
}

export class ActivityRate implements IActivityRate {
    id?: number | undefined;
    user?: User | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    isFixed!: boolean;

    constructor(data?: IActivityRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): ActivityRate {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["isFixed"] = this.isFixed;
        return data;
    }

    clone(): ActivityRate {
        const json = this.toJSON();
        let result = new ActivityRate();
        result.init(json);
        return result;
    }
}

export interface IActivityRate {
    id?: number | undefined;
    user?: IUser | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    isFixed: boolean;
}

export class ActivityExpanded implements IActivityExpanded {
    id?: number | undefined;
    project?: Project | undefined;
    name!: string;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    color?: string | undefined;

    constructor(data?: IActivityExpanded) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityExpanded {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityExpanded();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["color"] = this.color;
        return data;
    }

    clone(): ActivityExpanded {
        const json = this.toJSON();
        let result = new ActivityExpanded();
        result.init(json);
        return result;
    }
}

export interface IActivityExpanded {
    id?: number | undefined;
    project?: IProject | undefined;
    name: string;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    color?: string | undefined;
}

export class Activity implements IActivity {
    project?: number | undefined;
    id?: number | undefined;
    name!: string;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    color?: string | undefined;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project;
        data["id"] = this.id;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["color"] = this.color;
        return data;
    }

    clone(): Activity {
        const json = this.toJSON();
        let result = new Activity();
        result.init(json);
        return result;
    }
}

export interface IActivity {
    project?: number | undefined;
    id?: number | undefined;
    name: string;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    color?: string | undefined;
}

export class ActivityEntity implements IActivityEntity {
    parentTitle?: string | undefined;
    project?: number | undefined;
    id?: number | undefined;
    name!: string;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this activity */
    metaFields?: ActivityMeta[] | undefined;
    /** If no team is assigned, everyone can access the activity */
    teams?: Team[] | undefined;
    budget!: number;
    timeBudget!: number;
    budgetType?: string | undefined;
    color?: string | undefined;

    constructor(data?: IActivityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new ActivityMeta(item) : <ActivityMeta>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTitle = _data["parentTitle"];
            this.project = _data["project"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(ActivityMeta.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.budget = _data["budget"];
            this.timeBudget = _data["timeBudget"];
            this.budgetType = _data["budgetType"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTitle"] = this.parentTitle;
        data["project"] = this.project;
        data["id"] = this.id;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["budget"] = this.budget;
        data["timeBudget"] = this.timeBudget;
        data["budgetType"] = this.budgetType;
        data["color"] = this.color;
        return data;
    }

    clone(): ActivityEntity {
        const json = this.toJSON();
        let result = new ActivityEntity();
        result.init(json);
        return result;
    }
}

export interface IActivityEntity {
    parentTitle?: string | undefined;
    project?: number | undefined;
    id?: number | undefined;
    name: string;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this activity */
    metaFields?: IActivityMeta[] | undefined;
    /** If no team is assigned, everyone can access the activity */
    teams?: ITeam[] | undefined;
    budget: number;
    timeBudget: number;
    budgetType?: string | undefined;
    color?: string | undefined;
}

export class ActivityEditForm implements IActivityEditForm {
    name!: string;
    comment?: string | undefined;
    invoiceText?: string | undefined;
    /** Project ID */
    project?: number | undefined;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    visible?: boolean | undefined;
    billable?: boolean | undefined;

    constructor(data?: IActivityEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.invoiceText = _data["invoiceText"];
            this.project = _data["project"];
            this.color = _data["color"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
        }
    }

    static fromJS(data: any): ActivityEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["invoiceText"] = this.invoiceText;
        data["project"] = this.project;
        data["color"] = this.color;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        return data;
    }

    clone(): ActivityEditForm {
        const json = this.toJSON();
        let result = new ActivityEditForm();
        result.init(json);
        return result;
    }
}

export interface IActivityEditForm {
    name: string;
    comment?: string | undefined;
    invoiceText?: string | undefined;
    /** Project ID */
    project?: number | undefined;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    visible?: boolean | undefined;
    billable?: boolean | undefined;
}

export class ProjectCollection implements IProjectCollection {
    parentTitle?: string | undefined;
    customer?: number | undefined;
    id?: number | undefined;
    name!: string;
    start?: Date | undefined;
    end?: Date | undefined;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this project */
    metaFields?: ProjectMeta[] | undefined;
    /** If no team is assigned, everyone can access the project (also depends on the teams of the customer) */
    teams?: Team[] | undefined;
    color?: string | undefined;

    constructor(data?: IProjectCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new ProjectMeta(item) : <ProjectMeta>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTitle = _data["parentTitle"];
            this.customer = _data["customer"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(ProjectMeta.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ProjectCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTitle"] = this.parentTitle;
        data["customer"] = this.customer;
        data["id"] = this.id;
        data["name"] = this.name;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["color"] = this.color;
        return data;
    }

    clone(): ProjectCollection {
        const json = this.toJSON();
        let result = new ProjectCollection();
        result.init(json);
        return result;
    }
}

export interface IProjectCollection {
    parentTitle?: string | undefined;
    customer?: number | undefined;
    id?: number | undefined;
    name: string;
    start?: Date | undefined;
    end?: Date | undefined;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this project */
    metaFields?: IProjectMeta[] | undefined;
    /** If no team is assigned, everyone can access the project (also depends on the teams of the customer) */
    teams?: ITeam[] | undefined;
    color?: string | undefined;
}

export class ProjectRateForm implements IProjectRateForm {
    /** User ID */
    user?: number | undefined;
    /** The rate (eg. 10.5) */
    rate!: number;
    /** The internal rate (eg. 10.0 or 10) */
    internalRate?: number | undefined;
    /** If "true" each time record gets the same rate, regardless of its duration */
    isFixed?: boolean | undefined;

    constructor(data?: IProjectRateForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): ProjectRateForm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRateForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["isFixed"] = this.isFixed;
        return data;
    }

    clone(): ProjectRateForm {
        const json = this.toJSON();
        let result = new ProjectRateForm();
        result.init(json);
        return result;
    }
}

export interface IProjectRateForm {
    /** User ID */
    user?: number | undefined;
    /** The rate (eg. 10.5) */
    rate: number;
    /** The internal rate (eg. 10.0 or 10) */
    internalRate?: number | undefined;
    /** If "true" each time record gets the same rate, regardless of its duration */
    isFixed?: boolean | undefined;
}

export class ProjectRate implements IProjectRate {
    id?: number | undefined;
    user?: User | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    isFixed!: boolean;

    constructor(data?: IProjectRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): ProjectRate {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["isFixed"] = this.isFixed;
        return data;
    }

    clone(): ProjectRate {
        const json = this.toJSON();
        let result = new ProjectRate();
        result.init(json);
        return result;
    }
}

export interface IProjectRate {
    id?: number | undefined;
    user?: IUser | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    isFixed: boolean;
}

export class ProjectExpanded implements IProjectExpanded {
    id?: number | undefined;
    customer!: Customer;
    name!: string;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    color?: string | undefined;

    constructor(data?: IProjectExpanded) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.customer = data.customer && !(<any>data.customer).toJSON ? new Customer(data.customer) : <Customer>this.customer;
        }
        if (!data) {
            this.customer = new Customer();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : new Customer();
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ProjectExpanded {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectExpanded();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["color"] = this.color;
        return data;
    }

    clone(): ProjectExpanded {
        const json = this.toJSON();
        let result = new ProjectExpanded();
        result.init(json);
        return result;
    }
}

export interface IProjectExpanded {
    id?: number | undefined;
    customer: ICustomer;
    name: string;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    color?: string | undefined;
}

export class Project implements IProject {
    customer?: number | undefined;
    id?: number | undefined;
    name!: string;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    color?: string | undefined;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        data["id"] = this.id;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["color"] = this.color;
        return data;
    }

    clone(): Project {
        const json = this.toJSON();
        let result = new Project();
        result.init(json);
        return result;
    }
}

export interface IProject {
    customer?: number | undefined;
    id?: number | undefined;
    name: string;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    color?: string | undefined;
}

export class ProjectEntity implements IProjectEntity {
    parentTitle?: string | undefined;
    customer?: number | undefined;
    id?: number | undefined;
    name!: string;
    orderNumber?: string | undefined;
    orderDate?: Date | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    /** All visible meta (custom) fields registered with this project */
    metaFields?: ProjectMeta[] | undefined;
    /** If no team is assigned, everyone can access the project (also depends on the teams of the customer) */
    teams?: Team[] | undefined;
    budget!: number;
    timeBudget!: number;
    budgetType?: string | undefined;
    color?: string | undefined;

    constructor(data?: IProjectEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new ProjectMeta(item) : <ProjectMeta>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTitle = _data["parentTitle"];
            this.customer = _data["customer"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(ProjectMeta.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.budget = _data["budget"];
            this.timeBudget = _data["timeBudget"];
            this.budgetType = _data["budgetType"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ProjectEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTitle"] = this.parentTitle;
        data["customer"] = this.customer;
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["budget"] = this.budget;
        data["timeBudget"] = this.timeBudget;
        data["budgetType"] = this.budgetType;
        data["color"] = this.color;
        return data;
    }

    clone(): ProjectEntity {
        const json = this.toJSON();
        let result = new ProjectEntity();
        result.init(json);
        return result;
    }
}

export interface IProjectEntity {
    parentTitle?: string | undefined;
    customer?: number | undefined;
    id?: number | undefined;
    name: string;
    orderNumber?: string | undefined;
    orderDate?: Date | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    /** All visible meta (custom) fields registered with this project */
    metaFields?: IProjectMeta[] | undefined;
    /** If no team is assigned, everyone can access the project (also depends on the teams of the customer) */
    teams?: ITeam[] | undefined;
    budget: number;
    timeBudget: number;
    budgetType?: string | undefined;
    color?: string | undefined;
}

export class ProjectEditForm implements IProjectEditForm {
    name!: string;
    comment?: string | undefined;
    invoiceText?: string | undefined;
    orderNumber?: string | undefined;
    orderDate?: Date | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    /** Customer ID */
    customer!: number;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    visible?: boolean | undefined;
    billable?: boolean | undefined;

    constructor(data?: IProjectEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.invoiceText = _data["invoiceText"];
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.customer = _data["customer"];
            this.color = _data["color"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
        }
    }

    static fromJS(data: any): ProjectEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["invoiceText"] = this.invoiceText;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["color"] = this.color;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        return data;
    }

    clone(): ProjectEditForm {
        const json = this.toJSON();
        let result = new ProjectEditForm();
        result.init(json);
        return result;
    }
}

export interface IProjectEditForm {
    name: string;
    comment?: string | undefined;
    invoiceText?: string | undefined;
    orderNumber?: string | undefined;
    orderDate?: Date | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    /** Customer ID */
    customer: number;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    visible?: boolean | undefined;
    billable?: boolean | undefined;
}

export class CustomerCollection implements ICustomerCollection {
    id?: number | undefined;
    name!: string;
    number?: string | undefined;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    currency!: string;
    /** All visible meta (custom) fields registered with this customer */
    metaFields?: CustomerMeta[] | undefined;
    /** If no team is assigned, everyone can access the customer */
    teams?: Team[] | undefined;
    color?: string | undefined;

    constructor(data?: ICustomerCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new CustomerMeta(item) : <CustomerMeta>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(CustomerMeta.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CustomerCollection {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["currency"] = this.currency;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["color"] = this.color;
        return data;
    }

    clone(): CustomerCollection {
        const json = this.toJSON();
        let result = new CustomerCollection();
        result.init(json);
        return result;
    }
}

export interface ICustomerCollection {
    id?: number | undefined;
    name: string;
    number?: string | undefined;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    currency: string;
    /** All visible meta (custom) fields registered with this customer */
    metaFields?: ICustomerMeta[] | undefined;
    /** If no team is assigned, everyone can access the customer */
    teams?: ITeam[] | undefined;
    color?: string | undefined;
}

export class CustomerRateForm implements ICustomerRateForm {
    /** User ID */
    user?: number | undefined;
    /** The rate (eg. 10.5) */
    rate!: number;
    /** The internal rate (eg. 10.0 or 10) */
    internalRate?: number | undefined;
    /** If "true" each time record gets the same rate, regardless of its duration */
    isFixed?: boolean | undefined;

    constructor(data?: ICustomerRateForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): CustomerRateForm {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRateForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["isFixed"] = this.isFixed;
        return data;
    }

    clone(): CustomerRateForm {
        const json = this.toJSON();
        let result = new CustomerRateForm();
        result.init(json);
        return result;
    }
}

export interface ICustomerRateForm {
    /** User ID */
    user?: number | undefined;
    /** The rate (eg. 10.5) */
    rate: number;
    /** The internal rate (eg. 10.0 or 10) */
    internalRate?: number | undefined;
    /** If "true" each time record gets the same rate, regardless of its duration */
    isFixed?: boolean | undefined;
}

export class CustomerRate implements ICustomerRate {
    id?: number | undefined;
    user?: User | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    isFixed!: boolean;

    constructor(data?: ICustomerRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.rate = _data["rate"];
            this.internalRate = _data["internalRate"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): CustomerRate {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["rate"] = this.rate;
        data["internalRate"] = this.internalRate;
        data["isFixed"] = this.isFixed;
        return data;
    }

    clone(): CustomerRate {
        const json = this.toJSON();
        let result = new CustomerRate();
        result.init(json);
        return result;
    }
}

export interface ICustomerRate {
    id?: number | undefined;
    user?: IUser | undefined;
    rate?: number | undefined;
    internalRate?: number | undefined;
    isFixed: boolean;
}

export class Customer implements ICustomer {
    id?: number | undefined;
    name!: string;
    number?: string | undefined;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    color?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["color"] = this.color;
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    id?: number | undefined;
    name: string;
    number?: string | undefined;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    color?: string | undefined;
}

export class CustomerEntity implements ICustomerEntity {
    id?: number | undefined;
    name!: string;
    number?: string | undefined;
    comment?: string | undefined;
    visible!: boolean;
    billable!: boolean;
    company?: string | undefined;
    vatId?: string | undefined;
    contact?: string | undefined;
    address?: string | undefined;
    country!: string;
    currency!: string;
    phone?: string | undefined;
    fax?: string | undefined;
    mobile?: string | undefined;
    /** Limited via RFC to 254 chars */
    email?: string | undefined;
    homepage?: string | undefined;
    /** Length was determined by a MySQL column via "use mysql;describe time_zone_name;" */
    timezone!: string;
    /** All visible meta (custom) fields registered with this customer */
    metaFields?: CustomerMeta[] | undefined;
    /** If no team is assigned, everyone can access the customer */
    teams?: Team[] | undefined;
    budget!: number;
    timeBudget!: number;
    budgetType?: string | undefined;
    color?: string | undefined;

    constructor(data?: ICustomerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.metaFields) {
                this.metaFields = [];
                for (let i = 0; i < data.metaFields.length; i++) {
                    let item = data.metaFields[i];
                    this.metaFields[i] = item && !(<any>item).toJSON ? new CustomerMeta(item) : <CustomerMeta>item;
                }
            }
            if (data.teams) {
                this.teams = [];
                for (let i = 0; i < data.teams.length; i++) {
                    let item = data.teams[i];
                    this.teams[i] = item && !(<any>item).toJSON ? new Team(item) : <Team>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.comment = _data["comment"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
            this.company = _data["company"];
            this.vatId = _data["vatId"];
            this.contact = _data["contact"];
            this.address = _data["address"];
            this.country = _data["country"];
            this.currency = _data["currency"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.homepage = _data["homepage"];
            this.timezone = _data["timezone"];
            if (Array.isArray(_data["metaFields"])) {
                this.metaFields = [] as any;
                for (let item of _data["metaFields"])
                    this.metaFields!.push(CustomerMeta.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.budget = _data["budget"];
            this.timeBudget = _data["timeBudget"];
            this.budgetType = _data["budgetType"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CustomerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["comment"] = this.comment;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        data["company"] = this.company;
        data["vatId"] = this.vatId;
        data["contact"] = this.contact;
        data["address"] = this.address;
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["homepage"] = this.homepage;
        data["timezone"] = this.timezone;
        if (Array.isArray(this.metaFields)) {
            data["metaFields"] = [];
            for (let item of this.metaFields)
                data["metaFields"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["budget"] = this.budget;
        data["timeBudget"] = this.timeBudget;
        data["budgetType"] = this.budgetType;
        data["color"] = this.color;
        return data;
    }

    clone(): CustomerEntity {
        const json = this.toJSON();
        let result = new CustomerEntity();
        result.init(json);
        return result;
    }
}

export interface ICustomerEntity {
    id?: number | undefined;
    name: string;
    number?: string | undefined;
    comment?: string | undefined;
    visible: boolean;
    billable: boolean;
    company?: string | undefined;
    vatId?: string | undefined;
    contact?: string | undefined;
    address?: string | undefined;
    country: string;
    currency: string;
    phone?: string | undefined;
    fax?: string | undefined;
    mobile?: string | undefined;
    /** Limited via RFC to 254 chars */
    email?: string | undefined;
    homepage?: string | undefined;
    /** Length was determined by a MySQL column via "use mysql;describe time_zone_name;" */
    timezone: string;
    /** All visible meta (custom) fields registered with this customer */
    metaFields?: ICustomerMeta[] | undefined;
    /** If no team is assigned, everyone can access the customer */
    teams?: ITeam[] | undefined;
    budget: number;
    timeBudget: number;
    budgetType?: string | undefined;
    color?: string | undefined;
}

export class CustomerEditForm implements ICustomerEditForm {
    name!: string;
    number?: string | undefined;
    comment?: string | undefined;
    company?: string | undefined;
    vatId?: string | undefined;
    contact?: string | undefined;
    address?: string | undefined;
    country!: string;
    currency!: string;
    phone?: string | undefined;
    fax?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    homepage?: string | undefined;
    timezone!: string;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    visible?: boolean | undefined;
    billable?: boolean | undefined;

    constructor(data?: ICustomerEditForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.comment = _data["comment"];
            this.company = _data["company"];
            this.vatId = _data["vatId"];
            this.contact = _data["contact"];
            this.address = _data["address"];
            this.country = _data["country"];
            this.currency = _data["currency"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.homepage = _data["homepage"];
            this.timezone = _data["timezone"];
            this.color = _data["color"];
            this.visible = _data["visible"];
            this.billable = _data["billable"];
        }
    }

    static fromJS(data: any): CustomerEditForm {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEditForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["comment"] = this.comment;
        data["company"] = this.company;
        data["vatId"] = this.vatId;
        data["contact"] = this.contact;
        data["address"] = this.address;
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["homepage"] = this.homepage;
        data["timezone"] = this.timezone;
        data["color"] = this.color;
        data["visible"] = this.visible;
        data["billable"] = this.billable;
        return data;
    }

    clone(): CustomerEditForm {
        const json = this.toJSON();
        let result = new CustomerEditForm();
        result.init(json);
        return result;
    }
}

export interface ICustomerEditForm {
    name: string;
    number?: string | undefined;
    comment?: string | undefined;
    company?: string | undefined;
    vatId?: string | undefined;
    contact?: string | undefined;
    address?: string | undefined;
    country: string;
    currency: string;
    phone?: string | undefined;
    fax?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    homepage?: string | undefined;
    timezone: string;
    /** The hexadecimal color code (default: #d2d6de) */
    color?: string | undefined;
    visible?: boolean | undefined;
    billable?: boolean | undefined;
}

export class I18nConfig implements II18nConfig {
    formDate?: string | undefined;
    dateTime?: string | undefined;
    date?: string | undefined;
    time?: string | undefined;
    duration?: string | undefined;
    is24hours?: boolean | undefined;
    now?: Date | undefined;

    constructor(data?: II18nConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formDate = _data["formDate"];
            this.dateTime = _data["dateTime"];
            this.date = _data["date"];
            this.time = _data["time"];
            this.duration = _data["duration"];
            this.is24hours = _data["is24hours"];
            this.now = _data["now"] ? new Date(_data["now"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): I18nConfig {
        data = typeof data === 'object' ? data : {};
        let result = new I18nConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formDate"] = this.formDate;
        data["dateTime"] = this.dateTime;
        data["date"] = this.date;
        data["time"] = this.time;
        data["duration"] = this.duration;
        data["is24hours"] = this.is24hours;
        data["now"] = this.now ? this.now.toISOString() : <any>undefined;
        return data;
    }

    clone(): I18nConfig {
        const json = this.toJSON();
        let result = new I18nConfig();
        result.init(json);
        return result;
    }
}

export interface II18nConfig {
    formDate?: string | undefined;
    dateTime?: string | undefined;
    date?: string | undefined;
    time?: string | undefined;
    duration?: string | undefined;
    is24hours?: boolean | undefined;
    now?: Date | undefined;
}

export class TimesheetConfig implements ITimesheetConfig {
    trackingMode?: string | undefined;
    defaultBeginTime?: string | undefined;
    activeEntriesHardLimit?: number | undefined;
    activeEntriesSoftLimit?: number | undefined;
    isAllowFutureTimes?: boolean | undefined;
    isAllowOverlapping?: boolean | undefined;

    constructor(data?: ITimesheetConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingMode = _data["trackingMode"];
            this.defaultBeginTime = _data["defaultBeginTime"];
            this.activeEntriesHardLimit = _data["activeEntriesHardLimit"];
            this.activeEntriesSoftLimit = _data["activeEntriesSoftLimit"];
            this.isAllowFutureTimes = _data["isAllowFutureTimes"];
            this.isAllowOverlapping = _data["isAllowOverlapping"];
        }
    }

    static fromJS(data: any): TimesheetConfig {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingMode"] = this.trackingMode;
        data["defaultBeginTime"] = this.defaultBeginTime;
        data["activeEntriesHardLimit"] = this.activeEntriesHardLimit;
        data["activeEntriesSoftLimit"] = this.activeEntriesSoftLimit;
        data["isAllowFutureTimes"] = this.isAllowFutureTimes;
        data["isAllowOverlapping"] = this.isAllowOverlapping;
        return data;
    }

    clone(): TimesheetConfig {
        const json = this.toJSON();
        let result = new TimesheetConfig();
        result.init(json);
        return result;
    }
}

export interface ITimesheetConfig {
    trackingMode?: string | undefined;
    defaultBeginTime?: string | undefined;
    activeEntriesHardLimit?: number | undefined;
    activeEntriesSoftLimit?: number | undefined;
    isAllowFutureTimes?: boolean | undefined;
    isAllowOverlapping?: boolean | undefined;
}

export class Version implements IVersion {
    version?: string | undefined;
    /** Follows the same logic as PHP_VERSION_ID, see https://www.php.net/manual/de/function.phpversion.php */
    versionId?: number | undefined;
    candidate?: string | undefined;
    semver?: string | undefined;
    name?: string | undefined;
    copyright?: string | undefined;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.versionId = _data["versionId"];
            this.candidate = _data["candidate"];
            this.semver = _data["semver"];
            this.name = _data["name"];
            this.copyright = _data["copyright"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["versionId"] = this.versionId;
        data["candidate"] = this.candidate;
        data["semver"] = this.semver;
        data["name"] = this.name;
        data["copyright"] = this.copyright;
        return data;
    }

    clone(): Version {
        const json = this.toJSON();
        let result = new Version();
        result.init(json);
        return result;
    }
}

export interface IVersion {
    version?: string | undefined;
    /** Follows the same logic as PHP_VERSION_ID, see https://www.php.net/manual/de/function.phpversion.php */
    versionId?: number | undefined;
    candidate?: string | undefined;
    semver?: string | undefined;
    name?: string | undefined;
    copyright?: string | undefined;
}

export class Plugin implements IPlugin {
    name?: string | undefined;
    version?: string | undefined;

    constructor(data?: IPlugin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): Plugin {
        data = typeof data === 'object' ? data : {};
        let result = new Plugin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["version"] = this.version;
        return data;
    }

    clone(): Plugin {
        const json = this.toJSON();
        let result = new Plugin();
        result.init(json);
        return result;
    }
}

export interface IPlugin {
    name?: string | undefined;
    version?: string | undefined;
}

export class TimesheetMeta implements ITimesheetMeta {
    name!: string;
    value?: string | undefined;

    constructor(data?: ITimesheetMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TimesheetMeta {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): TimesheetMeta {
        const json = this.toJSON();
        let result = new TimesheetMeta();
        result.init(json);
        return result;
    }
}

export interface ITimesheetMeta {
    name: string;
    value?: string | undefined;
}

export class ActivityMeta implements IActivityMeta {
    name!: string;
    value?: string | undefined;

    constructor(data?: IActivityMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ActivityMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): ActivityMeta {
        const json = this.toJSON();
        let result = new ActivityMeta();
        result.init(json);
        return result;
    }
}

export interface IActivityMeta {
    name: string;
    value?: string | undefined;
}

export class ProjectMeta implements IProjectMeta {
    name!: string;
    value?: string | undefined;

    constructor(data?: IProjectMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProjectMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): ProjectMeta {
        const json = this.toJSON();
        let result = new ProjectMeta();
        result.init(json);
        return result;
    }
}

export interface IProjectMeta {
    name: string;
    value?: string | undefined;
}

export class CustomerMeta implements ICustomerMeta {
    name!: string;
    value?: string | undefined;

    constructor(data?: ICustomerMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomerMeta {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): CustomerMeta {
        const json = this.toJSON();
        let result = new CustomerMeta();
        result.init(json);
        return result;
    }
}

export interface ICustomerMeta {
    name: string;
    value?: string | undefined;
}

export class Body implements IBody {
    /** The meta-field name */
    name!: string;
    /** The meta-field value */
    value!: string;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Body {
        const json = this.toJSON();
        let result = new Body();
        result.init(json);
        return result;
    }
}

export interface IBody {
    /** The meta-field name */
    name: string;
    /** The meta-field value */
    value: string;
}

export class Body2 implements IBody2 {
    /** The meta-field name */
    name!: string;
    /** The meta-field value */
    value!: string;

    constructor(data?: IBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Body2 {
        const json = this.toJSON();
        let result = new Body2();
        result.init(json);
        return result;
    }
}

export interface IBody2 {
    /** The meta-field name */
    name: string;
    /** The meta-field value */
    value: string;
}

export class Body3 implements IBody3 {
    /** The meta-field name */
    name!: string;
    /** The meta-field value */
    value!: string;

    constructor(data?: IBody3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Body3 {
        data = typeof data === 'object' ? data : {};
        let result = new Body3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Body3 {
        const json = this.toJSON();
        let result = new Body3();
        result.init(json);
        return result;
    }
}

export interface IBody3 {
    /** The meta-field name */
    name: string;
    /** The meta-field value */
    value: string;
}

export class Body4 implements IBody4 {
    /** Whether data should be copied to the new entry. Allowed values: all, tags (deprecated), rates (deprecated), description (deprecated), meta (deprecated) (default: nothing is copied) */
    copy?: string | undefined;
    /** Changes the restart date to the given one (default: now) */
    begin?: string | undefined;

    constructor(data?: IBody4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copy = _data["copy"];
            this.begin = _data["begin"];
        }
    }

    static fromJS(data: any): Body4 {
        data = typeof data === 'object' ? data : {};
        let result = new Body4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copy"] = this.copy;
        data["begin"] = this.begin;
        return data;
    }

    clone(): Body4 {
        const json = this.toJSON();
        let result = new Body4();
        result.init(json);
        return result;
    }
}

export interface IBody4 {
    /** Whether data should be copied to the new entry. Allowed values: all, tags (deprecated), rates (deprecated), description (deprecated), meta (deprecated) (default: nothing is copied) */
    copy?: string | undefined;
    /** Changes the restart date to the given one (default: now) */
    begin?: string | undefined;
}

export class Body5 implements IBody5 {
    /** The meta-field name */
    name!: string;
    /** The meta-field value */
    value!: string;

    constructor(data?: IBody5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Body5 {
        data = typeof data === 'object' ? data : {};
        let result = new Body5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Body5 {
        const json = this.toJSON();
        let result = new Body5();
        result.init(json);
        return result;
    }
}

export interface IBody5 {
    /** The meta-field name */
    name: string;
    /** The meta-field value */
    value: string;
}

export class Members implements IMembers {
    /** User ID */
    user?: number | undefined;
    /** Whether the user is a teamlead */
    teamlead?: boolean | undefined;

    constructor(data?: IMembers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.teamlead = _data["teamlead"];
        }
    }

    static fromJS(data: any): Members {
        data = typeof data === 'object' ? data : {};
        let result = new Members();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["teamlead"] = this.teamlead;
        return data;
    }

    clone(): Members {
        const json = this.toJSON();
        let result = new Members();
        result.init(json);
        return result;
    }
}

export interface IMembers {
    /** User ID */
    user?: number | undefined;
    /** Whether the user is a teamlead */
    teamlead?: boolean | undefined;
}

export enum UserEditFormLanguage {
    Ar = "ar",
    Cs = "cs",
    Da = "da",
    De = "de",
    De_AT = "de_AT",
    De_CH = "de_CH",
    El = "el",
    En = "en",
    En_GB = "en_GB",
    Eo = "eo",
    Es = "es",
    Eu = "eu",
    Fa = "fa",
    Fi = "fi",
    Fo = "fo",
    Fr = "fr",
    He = "he",
    Hr = "hr",
    Hu = "hu",
    It = "it",
    Ja = "ja",
    Ko = "ko",
    Nb_NO = "nb_NO",
    Nl = "nl",
    Pl = "pl",
    Pt = "pt",
    Pt_BR = "pt_BR",
    Ro = "ro",
    Ru = "ru",
    Sk = "sk",
    Sv = "sv",
    Tr = "tr",
    Vi = "vi",
    Zh_CN = "zh_CN",
}

export enum Roles {
    ROLE_TEAMLEAD = "ROLE_TEAMLEAD",
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN",
}

export enum UserCreateFormLanguage {
    Ar = "ar",
    Cs = "cs",
    Da = "da",
    De = "de",
    De_AT = "de_AT",
    De_CH = "de_CH",
    El = "el",
    En = "en",
    En_GB = "en_GB",
    Eo = "eo",
    Es = "es",
    Eu = "eu",
    Fa = "fa",
    Fi = "fi",
    Fo = "fo",
    Fr = "fr",
    He = "he",
    Hr = "hr",
    Hu = "hu",
    It = "it",
    Ja = "ja",
    Ko = "ko",
    Nb_NO = "nb_NO",
    Nl = "nl",
    Pl = "pl",
    Pt = "pt",
    Pt_BR = "pt_BR",
    Ro = "ro",
    Ru = "ru",
    Sk = "sk",
    Sv = "sv",
    Tr = "tr",
    Vi = "vi",
    Zh_CN = "zh_CN",
}

export enum Roles2 {
    ROLE_TEAMLEAD = "ROLE_TEAMLEAD",
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}